//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableDetalheContatoSmsUnico extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
        
    }

    statusEnvio(status){
        if (status == "Enviado"){
            return( <span style={{color:"#009966"}}>Enviado</span>)
        }
        else if (status == "Entregue"){
            return( <span style={{color:"#EF7800"}}>Entregue</span>)
        }
        else if (status == "Entregue Aparelho"){
            return( <span style={{color:"#0099FF"}}>Entregue no Aparelho</span>)
        }
        else if (status == "Rejeitado"){
            return( <span style={{color:"#C34E4E"}}>Rejeitado</span>)
        }
        else if (status == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    render() {

        const data = this.props.data; let html = "";
        const loading = this.props.loading;

        if (loading) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results === undefined || data.results.length === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.codigo}</td>
                    <td>{ row.nomeContato }</td>
                    <td>{row.telefone}</td>
                    <td>{this.statusEnvio(row.status)}</td>                 
                    <td>{row.dataHoraEnvio}</td>
                    <td>{row.centroCusto}</td>
                    <td>{row.empresa}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <div className="box-export ml-auto">Exportar dados como:
                    {this.export('excel')}
                </div>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>Nome</th>
                            <th>Telefone</th>
                            <th>Status</th>
                            <th>Data/Hora do envio</th>
                            <th>Centro de custo</th>
                            <th>Empresa</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }

    export(tipo){
        if(tipo == "excel"){
            return(<TableToExcel id="test-table-xls-button" className="btn-export" table="table-to-export" filename="relatorio_envio_rastreado" buttonText="Excel"/>)
        }        
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalheContatoSmsUnico));